export default "__VITE_ASSET__CWpFEJEI__"